import { Link } from 'react-router-dom';
import {
  ArrowRight,
  Calendar,
  Calculator,
  DollarSign,
  History,
  PackageOpen,
  Plus,
  UserCircle,
  Users,
  Wallet2
} from 'lucide-react';

const QUICK_ACTIONS = [
  {
    to: '/admin/calculadora',
    label: 'Registro de créditos',
    description: 'Crear y simular préstamos de forma operativa.',
    icon: Calculator
  },
  {
    to: '/admin/productos',
    label: 'Productos',
    description: 'Actualizar condiciones y catálogo financiero.',
    icon: PackageOpen
  },
  {
    to: '/admin/clientes',
    label: 'Clientes',
    description: 'Gestionar fichas y seguimiento comercial.',
    icon: Users
  },
  {
    to: '/admin/asignar-avales',
    label: 'Asignar avales',
    description: 'Vincular garantías para nuevos desembolsos.',
    icon: Plus
  },
  {
    to: '/admin/asesores',
    label: 'Empleados',
    description: 'Supervisar equipos, permisos y carga diaria.',
    icon: UserCircle
  },
  {
    to: '/admin/estados',
    label: 'Registro de cuotas',
    description: 'Confirmar pagos y estado de cobranza.',
    icon: DollarSign
  },
  {
    to: '/admin/gestion-moras',
    label: 'Gestión de moras',
    description: 'Supervisar compromisos y créditos vencidos por asesor.',
    icon: History
  },
  {
    to: '/admin/pagos/filtros',
    label: 'Filtrar pagos',
    description: 'Aplicar filtros por cliente, fechas y mora.',
    icon: Wallet2
  },
  {
    to: '/admin/historial-prestamos',
    label: 'Historial préstamos',
    description: 'Auditar movimientos y trazabilidad.',
    icon: History
  },
  {
    to: '/admin/cronograma',
    label: 'Cronogramas',
    description: 'Consultar vencimientos y planificación.',
    icon: Calendar
  }
];

export default function Inicio() {
  return (
    <div className="space-y-6">
      <section className="ui-card relative overflow-hidden px-6 py-7 md:px-8">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_90%_10%,rgba(217,44,52,0.15),transparent_42%)]" />
        <div className="relative">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-red-600">Panel administrativo</p>
            <h1 className="mt-2 text-2xl font-semibold text-slate-900 md:text-3xl">Centro operativo de cartera</h1>
            <p className="mt-2 max-w-2xl text-sm text-slate-600">
              Atajos de gestión para créditos, pagos, seguimiento de clientes y control diario.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-sm font-semibold uppercase tracking-[0.22em] text-slate-500">Acciones rápidas</h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {QUICK_ACTIONS.map((item) => {
            const Icon = item.icon;

            return (
              <Link
                key={item.to}
                to={item.to}
                className="ui-card group flex min-h-[148px] flex-col justify-between p-5 transition hover:-translate-y-0.5 hover:border-red-200 hover:shadow-[0_18px_35px_-26px_rgba(185,28,28,0.55)]"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-xl bg-red-50 p-2 text-red-600">
                    <Icon size={18} />
                  </span>
                  <ArrowRight size={16} className="text-slate-300 transition group-hover:translate-x-0.5 group-hover:text-red-500" />
                </div>
                <div className="mt-4">
                  <h3 className="text-base font-semibold text-slate-900">{item.label}</h3>
                  <p className="mt-1 text-sm text-slate-600">{item.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

    </div>
  );
}